module.exports = __webpack_public_path__ + "img/dashboard-icon.728ea45e.svg";